import apiService from '../../../repositories/apiService';

export default {
    getPeople({ commit }) {
        return this.dispatch(
            'People/Pagination/paginatedFetch',
            '/people/viewablePeople',
        )
            .then((response) => {
                commit('setPeople', response.data.data);
            })
            .catch((error) => {
                commit('setError', error);
            });
    },
    getPersonById(state, payload) {
        return new Promise((resolve, reject) => {
            apiService.get(
                `/people/${payload.personId}`
            )
                .then((response) => {
                    state.commit('setPerson', response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    state.commit('setError', error);
                    reject(error);
                });
        });
    },
    updatePerson(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .put(`/people/${payload.person_id}`, payload)
                .then((response) => {
                    // state.commit('setPerson', response.data.data);
                    resolve(response.data.person_id);
                })
                .catch((error) => {
                    state.commit('setError', error);
                    reject(error);
                });
        });
    },
    getGenders(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/list_items/genders')
                .then((response) => {
                    state.commit('setGenders', response.data);
                })
                .catch((error) => {
                    state.commit('setError', error);
                });
        });
    },
    getSchoolYears(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/list_items/schoolYears')
                .then((response) => {
                    state.commit('setSchoolYears', response.data);
                })
                .catch((error) => {
                    state.commit('setError', error);
                });
        });
    },
    getLocations(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/locations/focus')
                .then((response) => {
                    state.commit('setLocations', response.data);
                })
                .catch((error) => {
                    state.commit('setError', error);
                });
        });
    },
    getRoles(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/roles')
                .then((response) => {
                    state.commit('setRoles', response.data);
                })
                .catch((error) => {
                    state.commit('setError', error);
                });
        });
    },
    storePerson(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .post('/people', payload)
                .then((response) => {
                    resolve(response.data.person_id);
                })
                .catch((error) => {
                    state.commit('setError', error);
                    reject(error);
                });
        });
    },
};
